import axios from 'axios';

const api = process.env.REACT_APP_SERVER_URL;
const apiKey = process.env.REACT_APP_UMMAHFY_API_KEY;

/**
 * Get all tickets for a user by email
 * @param {string} email - User's email
 * @returns {Promise<Array>} - Array of ticket objects
 */
export const getUserTicketsByEmail = async (email) => {
  try {
    console.log(`Fetching tickets for user email: ${email}`);
    console.log(`API URL: ${api}tickets/user/email/${encodeURIComponent(email)}`);
    
    const response = await axios.get(`${api}tickets/user/email/${encodeURIComponent(email)}`, {
      headers: {
        'x-api-key': apiKey
      }
    });
    
    console.log('User tickets API response:', response.data);
    const raw = response.data;
    if (Array.isArray(raw)) return raw;
    if (Array.isArray(raw?.data)) return raw.data;
    if (Array.isArray(raw?.tickets)) return raw.tickets;
    return [];
  } catch (error) {
    console.error('Failed to fetch user tickets:', error);
    console.error('Error details:', error.response ? error.response.data : error.message);
    throw error;
  }
};

/**
 * Get all tickets for an event
 * @param {string|number} eventId - Event ID
 * @returns {Promise<Array>} - Array of ticket objects
 */
export const getEventTickets = async (eventId) => {
  try {
    const response = await axios.get(`${api}tickets/event/${eventId}`, {
      headers: {
        'x-api-key': apiKey
      }
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch event tickets:', error);
    throw error;
  }
};

/**
 * Get a specific ticket by ID
 * @param {string} ticketId - Ticket ID
 * @returns {Promise<Object>} - Ticket object
 */
export const getTicketById = async (ticketId) => {
  try {
    const response = await axios.get(`${api}tickets/${ticketId}`, {
      headers: {
        'x-api-key': apiKey
      }
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch ticket:', error);
    throw error;
  }
};

/**
 * Verify a ticket and mark it as used
 * @param {string} ticketId - Ticket ID
 * @returns {Promise<Object>} - Verification result
 */
export const verifyTicket = async (ticketId) => {
  try {
    const response = await axios.post(`${api}tickets/verifyTicket`, {
      ticketId
    }, {
      headers: {
        'x-api-key': apiKey
      }
    });
    return response.data;
  } catch (error) {
    console.error('Failed to verify ticket:', error);
    throw error;
  }
};

/**
 * Get tickets for a user for a specific event
 * @param {string} email - User's email
 * @param {string|number} eventId - Event ID
 * @returns {Promise<Array>} - Array of ticket objects for the event
 */
export const getUserEventTickets = async (email, eventId) => {
  try {
    const tickets = await getUserTicketsByEmail(email);
    const list = Array.isArray(tickets) ? tickets : [];
    return list.filter(
      (ticket) =>
        ticket &&
        ticket.eventId != null &&
        ticket.eventId.toString() === String(eventId)
    );
  } catch (error) {
    console.error('Failed to fetch user event tickets:', error);
    throw error;
  }
};

/**
 * Create a ticket for a free event
 * @param {Object} ticketData - Ticket data
 * @param {string|number} ticketData.eventId - Event ID
 * @param {string} ticketData.userId - User ID
 * @param {string} ticketData.email - User email
 * @param {string} ticketData.qrCodeUrl - QR code URL
 * @returns {Promise<Object>} - Created ticket object
 */
export const createFreeTicket = async (ticketData) => {
  try {
    console.log('Creating free ticket with data:', ticketData);
    
    const response = await axios.post(`${api}tickets/createFreeTicket`, ticketData, {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey
      }
    });
    
    console.log('Free ticket created:', response.data);
    return response.data;
  } catch (error) {
    console.error('Failed to create free ticket:', error);
    console.error('Error details:', error.response ? error.response.data : error.message);
    throw error;
  }
}; 